// noinspection All

import { client, env, server } from 'config/environment'
import Script from 'next/script'

// language=javascript
const SCRIPT = `
  // @formatter:off
  (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();
    for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
    k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
  (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
  ym(YAMA_ID, "init", {
    clickmap:true,
    trackLinks:true,
    accurateTrackBounce:true,
    webvisor:true
  });
  // @formatter:on
`

function id(): number {
  return env.production ? 100044323 : 106588076
}

export function yama() {
  if (env.development) return null
  if (env.domain === 'atelier') return null

  let script = SCRIPT
  script = script.replace('YAMA_ID', JSON.stringify(id()))
  script = script.replace(/^\s*\/\/.*$/gm, '')

  return <Script id="metrika" strategy="beforeInteractive" children={script} />
}

export function ym(goal: string, data?: object): void {
  if (client && window.ym) {
    window.ym(id(), 'reachGoal', goal, data)
  }
}
